import { DrilldownDataContext } from 'features/drilldown'
import { useContext, useMemo } from 'react'
import { DrilldownPanelGroupType } from 'types'

import { DrilldownPanelConfig } from './PanelConfigs'
import { PANEL_FLAGS_BY_ORG } from './panelFeatureFlags'
import { DRILLDOWN_BUTTON_GROUPINGS } from './PanelGroupConfigs'

/**
 * Hook that reads the current organization and computes the org groupings
 * after removing non-globally available panels for the current org
 */
export const useEnabledPanelsByGroup = (): ReadonlyArray<
  [DrilldownPanelGroupType, DrilldownPanelConfig[]]
> => {
  const { orgId } = useContext(DrilldownDataContext)

  return useMemo<
    ReadonlyArray<[DrilldownPanelGroupType, DrilldownPanelConfig[]]>
  >(() => {
    const orgSpecificPanels = orgId ? PANEL_FLAGS_BY_ORG[orgId] || [] : []

    return Object.entries(DRILLDOWN_BUTTON_GROUPINGS).map<
      [DrilldownPanelGroupType, DrilldownPanelConfig[]]
    >(([groupType, panels]) => {
      const filteredPanels = panels.filter((panel) => {
        const isGloballyAvailable = panel.isGloballyAvailable === true
        const isOrgSpecific = orgSpecificPanels.includes(panel.name)
        return isGloballyAvailable || isOrgSpecific
      })

      return [groupType as DrilldownPanelGroupType, filteredPanels]
    })
  }, [orgId])
}
